import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { EASE } from "@/components/Motion";

export default function Lightbox({ image, onClose }) {
  useEffect(() => {
    const handler = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onClose]);

  return (
    <AnimatePresence>
      {image && (
        <motion.div
          data-testid="slab-lightbox"
          className="fixed inset-0 z-[100] bg-[#101625]/95 backdrop-blur-sm flex flex-col items-center justify-center p-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          onClick={onClose}
        >
          <button
            data-testid="lightbox-close"
            onClick={onClose}
            aria-label="Close"
            className="absolute top-5 right-5 md:top-8 md:right-8 text-white/60 hover:text-white transition-colors duration-300"
          >
            <X className="w-7 h-7" />
          </button>
          <motion.img
            src={image.src}
            alt={image.name}
            initial={{ scale: 0.94, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.96, opacity: 0 }}
            transition={{ duration: 0.45, ease: EASE }}
            className="max-h-[76vh] max-w-full object-contain shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15, duration: 0.4 }}
            className="mt-6 text-center"
          >
            <p className="font-serif text-2xl md:text-3xl font-light text-white tracking-tight" data-testid="lightbox-name">
              {image.name}
            </p>
            {image.series && (
              <p className="mt-1 text-[10px] tracking-[0.25em] uppercase text-white/50">{image.series}</p>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
